// About.js
import React from 'react'
import Navbar from '../component/Navbar';
import Footer from '../component/Footer';
import { HashLink as Link } from 'react-router-hash-link';

function About() {
  const link = require('../img/href.png');

  return (
    <div>
      <Navbar />
      <section className='AboutUs'>
        <p className='SmHeading'>
          ABOUT US
        </p>
        <p className='BigHeading'>
          WE ARE TAK STUDIO.
        </p>
        <div className='DescriptionWrapper'>
          <p className='TeamOf'>
            A team of designers, developers,<br/>
            3D artists, and AI specialists.
          </p>
          <p className='Founded'>
            Founded by Ukrainians based in Berlin on the belief that technology and creativity are the same force — just expressed differently.
          </p>
        </div>
      </section>
      <section className='Values'>
        <p className='SmHeading'>
          VALUES
        </p>
        <p className='BigHeading'>
          WHAT DRIVES US
        </p>
        <div className='ServiceBlockPart FirstOne'>
          <p className='Numeric'>
            (01)
          </p>
          <p className='Servicename'>
            CRAFT FIRST
          </p>
          <p className='ServiceElement'>
            Every detail matters. We obsess over quality at every stage — from strategy to the final pixel.
          </p>
          <Link to='/services' className='MobileHidden'><img src = {link} className='HrefArrow'/></Link>
        </div>
        <div className='ServiceBlockPart'>
          <p className='Numeric'>
            (02)
          </p>
          <p className='Servicename'>
            FUTURE-READY
          </p>
          <p className='ServiceElement'>
            We embrace emerging tech before it becomes mainstream. 3D, AI, motion — we are always ahead.
          </p>
          <Link to='/services' className='MobileHidden'><img src = {link} className='HrefArrow'/></Link>
        </div>
        <div className='ServiceBlockPart'>
          <p className='Numeric'>
            (03)
          </p>
          <p className='Servicename'>
            TRANSPARENT
          </p>
          <p className='ServiceElement'>
            Honest timelines. Honest pricing. Honest feedback. No surprises, ever.
          </p>
          <Link to='/services' className='MobileHidden'><img src = {link} className='HrefArrow'/></Link>
        </div>
        <div className='ServiceBlockPart'>
          <p className='Numeric'>
            (04)
          </p>
          <p className='Servicename'>
            RESULTS-DRIVEN
          </p>
          <p className='ServiceElement'>
            Beautiful work that also performs. Design that converts and copy that resonates.
          </p>
          <Link to ='/services' className='CheckA'><p className='MobileOnly Check'>Check it out yourself</p><img src = {link} className='HrefArrow'/></Link>
        </div>
      </section>
      {/*<section className='TheTeam'>

      </section>*/}
      <Footer/> 
    </div>
   )
 }

 export default About
